const { resolveRouteCreatedAt } = require('../../../routes/tools/route-created-at')

const updateSubOrderWithRoute = async function (state, {subOrderId, routeId, routeCreatedAt}) {
  let subOrder = await state.dal.order.getSuborder(state, {suborderId: subOrderId, raw: true})
  if (!subOrder) {
    const err = new Error(
      `No suborder with id "${subOrderId}" was found. Cannot continue.`
    )
    throw err
  }
  const updatedOrderDoc = {
    ...subOrder,
    routeId,
    // Spreading the suborder would otherwise leave the previous route's
    // creation date sitting under the new routeId, and moveShipmentStatus
    // copies it from here onto every snapshot the order goes on to create —
    // so the wrong date would reach every stage (issue #25744).
    routeCreatedAt: resolveRouteCreatedAt(subOrder, routeId, routeCreatedAt)
  }

  const updatedSubOrder = await state.dal.order.update(state, updatedOrderDoc)

  return updatedSubOrder
}

module.exports = { updateSubOrderWithRoute }
